<mat-form-field color="accent-darker" appearance="outline">
    <mat-label>{{Etiquetas.FilterRegion}}</mat-label>
    <mat-select [(value)]="selectedRegionId" (selectionChange)="selectRegion($event.value)">
        <mat-option [value]="-1">Todas</mat-option>
        <mat-option *ngFor="let r of regiones" [value]="r.id">
            {{r.displayValue}}
        </mat-option>
    </mat-select>
</mat-form-field>